export default __webpack_public_path__ + "media/images/long-arrow-a35e1682b583a21382c6618c17cdf749.svg";